import React from "react";

interface FilterTabIconProps {
  className?: string;
}

export const MobilePhoneTabIcon: React.FC<FilterTabIconProps> = ({ className }) => (
  <svg
    className={className}
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <rect
      x="3.5"
      y="1"
      width="7"
      height="12"
      rx="1.5"
      stroke="currentColor"
      strokeWidth="1.15"
    />
    <circle cx="7" cy="10.75" r="0.55" fill="currentColor" />
  </svg>
);

export const WalletTabIcon: React.FC<FilterTabIconProps> = ({ className }) => (
  <svg
    className={className}
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M1.75 4.25C1.75 3.42 2.42 2.75 3.25 2.75H10.75C11.58 2.75 12.25 3.42 12.25 4.25V5.5H3.25C2.42 5.5 1.75 6.17 1.75 7V10.75C1.75 11.58 2.42 12.25 3.25 12.25H10.75C11.58 12.25 12.25 11.58 12.25 10.75V9.5"
      stroke="currentColor"
      strokeWidth="1.15"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.25 5.5V7.75C12.25 8.44 11.69 9 11 9H10.25C9.42 9 8.75 8.33 8.75 7.5C8.75 6.67 9.42 6 10.25 6H12.25"
      stroke="currentColor"
      strokeWidth="1.15"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CreditCardTabIcon: React.FC<FilterTabIconProps> = ({ className }) => (
  <svg
    className={className}
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <rect
      x="1.25"
      y="3.25"
      width="11.5"
      height="7.5"
      rx="1.25"
      stroke="currentColor"
      strokeWidth="1.15"
    />
    <path d="M1.25 5.75H12.75" stroke="currentColor" strokeWidth="1.15" />
    <path
      d="M3.5 8.75H5.75"
      stroke="currentColor"
      strokeWidth="1.15"
      strokeLinecap="round"
    />
  </svg>
);

export const FILTER_TAB_ICONS: Record<string, React.FC<FilterTabIconProps>> = {
  All: MobilePhoneTabIcon,
  "Apple Wallet": MobilePhoneTabIcon,
  "Google Wallet": WalletTabIcon,
  "Samsung Wallet": MobilePhoneTabIcon,
  "App Based": CreditCardTabIcon,
};
